import { checkImg } from '@/api/index'

export function getImg (data) {
  return checkImg.request({
    method: 'post',
    url: '/Getimg',
    data
  })
}
export function GetImg (data) {
  return checkImg.request({
    method: 'post',
    url: '/getimg',
    data
  })
}
export function delpicture (data) {
  return checkImg.request({
    method: 'post',
    url: '/delpicture',
    data
  })
}

export function uploadImg (data) {
  return checkImg.request({
    url: '/UploadImg',
    method: 'post',
    data,
    iSFromData: true
  })
}

export function GetImgCommon (data) {
  return checkImg.request({
    method: 'post',
    url: '/GetImgCommon',
    data
  })
}

export function DelpictureByID (data) {
  return checkImg.request({
    method: 'post',
    url: '/DelpictureByID',
    data
  })
}

export function UploadImgGPYS (data) {
  return checkImg.request({
    method: 'post',
    url: '/UploadImgGPYS',
    data
  })
}
